import { Component, computed, inject, output } from '@angular/core'
import { RouterLink } from '@angular/router'
import { CdkMenu, CdkMenuItem, CdkMenuTrigger } from '@angular/cdk/menu'

import { AuthService } from '@core/auth'
import { Icon } from '@shared/components'

@Component({
  selector: 'app-header',
  imports: [RouterLink, CdkMenu, CdkMenuItem, CdkMenuTrigger, Icon],
  templateUrl: './header.html'
})
export class Header {
  #authService = inject(AuthService)

  menuToggle = output<void>()

  initials = computed(() => {
    const name = this.#authService.currentUser()?.name ?? ''
    return (
      name
        .trim()
        .split(/\s+/)
        .map(part => part[0])
        .slice(0, 2)
        .join('')
        .toUpperCase() || 'SH'
    )
  })

  async onLogout(): Promise<void> {
    await this.#authService.logout()
  }
}
